import { Tooltip } from '@mui/material';
import RowActions from '@components/row-actions/row-actions.tsx';

export const playlistsColumns = (
  handleEdit: (row: any) => void,
  handleDelete: (row: any) => void
) => [
  {
    id: 'name',
    label: 'column_label_playlist_name',
    field: 'name',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'url',
    label: 'column_label_url',
    field: 'url',
    render: (value: any) => (
      <Tooltip title={value || 'N/A'} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'type',
    label: 'column_label_type',
    field: 'type',
    render: (value: any) => (
      <Tooltip title={value || 'N/A'} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    render: (value: any, row: any) => (
      <RowActions<any>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
